import CrudRepository from './CrudRepository'
import Repository from './Repository'
import Store from '../store'
export default class SegmentCategoriesTow extends CrudRepository {
  constructor (id) {
    super(`core/api/segments/${id}/categories/`)
  }

  async getSegmentCategory (id, page, perPage, type, line) {
    const gsm = Store.state.selectedNumber
    const search = Store.state.searchValue
    const requestParams = {
      page: page,
      size: perPage,
      type: type,
      lineType: gsm === null ? line : 2,
      gsm: gsm === null ? null : gsm,
      search: search
    }
    const requestData = await Repository.get(`${this.resource}${id}/bundles/web`, { params: requestParams })
    return {
      status: requestData.status,
      content: requestData.data.data.data,
      totalPage: requestData.data.data.totalPages,
      perPage: requestData.data.data.size,
      count: requestData.data.data.totalElements
    }
  }

  async get (id, line) {
    // const data = await Repository.get('core/api/segments/' + id + '/categories/', { params: { lineType: line } })
    const data = await Repository.get('core/api/segments/' + id + '/categories')
    return data.data
  }
}
